import React from 'react';
import locales from '../../../content.json';
import s from './vetSupportBlock.module.scss';
import sparkle from './img/star.png';
import flower from './img/flower.png';
import cross from './img/cross.png';
import phoneChat from './img/phone-chat.png';
import doctorAvatar from './img/doctor-avatar.png';

export const VetSupportBlock = () => {
  return (
    <section className={s.block}>
      <div className={s.badge}>
        <img className={s.badgeIcon} src={sparkle} alt="" aria-hidden="true" />
        <p className={s.badgeText}>{locales[window.userLang].payment_text_290}</p>
        <img className={s.badgeIcon} src={sparkle} alt="" aria-hidden="true" />
      </div>

      <div className={s.card}>
        <h3 className={s.title}>{locales[window.userLang].payment_text_291}</h3>

        <img className={`${s.decor} ${s.decorFlower}`} src={flower} alt="" aria-hidden="true" />
        <img className={`${s.decor} ${s.decorCross}`} src={cross} alt="" aria-hidden="true" />
        <img className={s.illustration} src={phoneChat} alt="" aria-hidden="true" />
      </div>

      <div className={s.avatarCard}>
        <img className={s.avatarImage} src={doctorAvatar} alt="" aria-hidden="true" />
      </div>
    </section>
  );
};
